<template>
    <div>
        <div class="second-box">
            <p class="title">数据统计</p>
            <div>
                <div class="js-item">
                    <p>浏览量：</p>
                    <div>{{ numberDivide(detail.viewCount) }}</div>
                </div>
                <div class="js-item">
                    <p>学习人数：</p>
                    <div>{{ numberDivide(statistics.studyCount) }}</div>
                </div>
                <div class="js-item">
                    <p>学习次数：</p>
                    <div>{{ numberDivide(statistics.studyNumberCount) }}</div>
                </div>
                <div class="js-item">
                    <p>平均用时：</p>
                    <div>{{ (statistics.avgTime||0)+'分钟' }}</div>
                </div>
                <div class="js-item">
                    <p>完成率：</p>
                    <div>{{ !statistics.finish?0:statistics.finish+'%' }}</div>
                </div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="three-box">
            <p class="title">推荐课程</p>
            <div v-for="(item,index) in reCourse" @click="toDetail(item)" class="re-item" :key="index">
                <img class="img-cover-all" :src="item.coverImageUrl?$severUrl(item.coverImageUrl):$filterResDefault(item.classifyCode)" style="object-fit: cover;" alt="">
                <div class="item">
                    <div>{{ item.name }}</div>
                    <div>{{ item.schoolName||'暂无' }}</div>
                    <div style="display: flex;">
                        <span style="margin-right: 0.5rem;">{{ item.evaluateScore }}</span>
                        <span><el-rate disabled v-model="item.evaluateScore"></el-rate></span>
                    </div>
                </div>
            </div>
            <no-data v-if="reCourse.length==0" style="margin-top: 3rem;"></no-data>
        </div>
    </div>
</template>

<script>
import { createChart } from '../echarts';
import { numberDivide } from '@/utils/utils';
import {QueryCourseDetail,GetCourseDataStatistics,GetCourseStudyStatus} from '@/api/course';
import { QueryRecommendCourse } from '@/api/recommend';
import Utils from '@/assets/js/Utils';
import { OPERATIONTYPE } from '@/utils/utils';
import NoData from '../../common/NoData.vue';
    export default {
        props:{
            id:{
                default:''
            }
    },
  components: { NoData },
        data(){
            return {
                OPERATIONTYPE,
                /**数据统计 */
                statistics:{},
                /**是否达标图表统计 */
                standardStatistics:[],
                /**推荐课程 */
                reCourse:[],
                /**chart实例 */
                myChart:null,
            }
        },
        methods:{
            numberDivide,
            /**获取推荐课程 */
            queryRecommendCourse(){
                var params={
                    "classifyCode": this.detail.classifyCode,
                    "id":this.courseId
                }
                QueryRecommendCourse(params).then(res=>{
                    if(res.code==200){
                        this.reCourse=res.data;
                    }
                })
            },
            /**推荐课程进入详情 */
            toDetail(item){
                if(this.$route.meta.classify=='manage'){
                    Utils.$emit('change_course_item',item);
                    let dom=document.querySelector('.detail-box');
                    if(dom){
                        dom.scrollTo(0, 0);
                    }
                }else{
                    this.$router.replace({
                        query:{
                            id:item.id
                        }
                    })
                    window.scrollTo(0, 0);
                }
                this.$nextTick(()=>{
                    this.queryCourseDetail();
                    this.getCourseDataStatistics();
                })
            },
            /**获取课程学习状态 */
            getCourseStudyStatus(){
                return new Promise(resolve=>{
                    GetCourseStudyStatus({id:this.courseId}).then(res=>{
                    if(res.code==200){
                        resolve(res.data);
                    }
                })
                })
            },
            /**查询课程详情数据统计 */
            getCourseDataStatistics(){
                GetCourseDataStatistics({id:this.courseId}).then(res=>{
                    if(res.code==200){
                        this.statistics=res.data;
                        var data={
                            '优秀':0,
                            '达标':0,
                            '不达标':0
                        };
                        let courseStandards=res.data.courseStandards;
                        courseStandards&&courseStandards.forEach(item=>{
                            data[item.achievementLevel]=item.studentCount;
                        })
                        this.myChart=createChart('chart-box',data);
                    }
                })
            },
            /**获取课程详情 */
            queryCourseDetail(){
                QueryCourseDetail({id:this.courseId}).then(res=>{
                    if(res.code==200){
                        this.getCourseStudyStatus().then(res1=>{
                            res.data.isStudy=res1;
                            var data={
                            label:'detail',
                            value:res.data
                        }
                        this.$store.commit('course/changeCourseDetail',data);
                        localStorage.setItem('base_detail',JSON.stringify(res.data));
                        this.queryRecommendCourse();
                        })
                    }
                })
            },
            /**更新chart */
            resizeChart(){
                this.myChart&&this.myChart.resize();
            }
        },
        computed:{
            detail(){
                return this.$store.state.course.courseDetailData.detail;
            },
            operationStatisticsInfo(){
                return this.$store.state.course.operationStatisticsInfo;
            },
            courseId(){
                return this.$route.query.id||this.id;
            }
        },
        mounted(){
            window.addEventListener('resize',this.resizeChart);
            this.queryCourseDetail();
            this.getCourseDataStatistics();
            Utils.$on('query_recommend',this.queryRecommendCourse);
        },
        destroyed(){
            window.removeEventListener('resize',this.resizeChart);
        }
    }
</script>

<style lang="less" scoped>
.title{
    color: #151C34;
    font-size: 2rem;
}
.js-item{
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 2rem;
    &> :nth-child(1){
        color: #8590B3;
    }
    &> :nth-child(2){
        color: #151C34;
    }
}
.btn-box{
    margin: 2.5rem 0;
    display: flex;
    align-items: center;
    color: #8590B3;
    &> :nth-child(3){
        display: flex;
        align-items: center;
        margin-left: 2rem;
        i{
            margin-right: 0.5rem;
            cursor: pointer;
        }
    }
    &> :nth-child(4){
        display: flex;
        align-items: center;
        margin-left: 2rem;
        i{
            margin-right: 0.5rem;
            cursor: pointer;
        }
    }
}
.first-box{
    border-bottom: 1px solid #dedede;
}
.second-box{
    padding:3rem ;
    background-color: #ffffff;
    #chart-box{
        height: 13rem;
        margin: 2rem 0;
    }
}
.three-box{
    padding:3rem ;
    background-color: #ffffff;
    margin-top: 2rem;
}
.re-item{
    display: flex;
    margin-top: 2rem;
    color: #334681;
    cursor: pointer;
    .item{
        font-size: 16px;
        margin-left: 2rem;
        &> :nth-child(2){
        font-size: 14px;
        color: #8590B3;
        margin-top: 0.5rem;
        }
        &> :nth-child(3){
            color: #FFE769;
            font-weight: 700;
            margin-top: 1rem;
        }
    }
    img{
        width: 14rem;
        aspect-ratio: var(--aspectRatio);
    }
}

</style>